export default __webpack_public_path__ + "static/media/haj7.dd0ce1ba.JPG";